// extracted by mini-css-extract-plugin
export var taglist = "taglist-module--taglist--fE9mN";
export var taglist__tag = "taglist-module--taglist__tag--BEYJe";